module.exports = __webpack_public_path__ + "media/images/admin/icons/camera-off-7dbefbfd70a575bc4e88578c5e5f26de.svg";